import React, { createContext, useContext, useMemo, useReducer, useRef, useState } from 'react'

import { ModalView } from '../components/transpais'
import { recordFlightEvent } from '../debug/flightRecorder'

const ModalViewContext = createContext(null)

export function ModalViewProvider({children, cancelable = true}) {
  const [, forceUpdate] = useReducer(x => x + 1, 0)

  const [show, setShow] = useState(false)

  const content = useRef('')
  const title = useRef('')
  const onCancelRef = useRef(null)

  function showModalView() {
    if (isModalViewVisible()) {
      forceUpdate()
    }
    recordFlightEvent('MODAL_VIEW:SHOW', { title: title.current || null }, 'ModalViewProvider.showModalView')
    setShow(true)
  }

  function hideModalView() {
    recordFlightEvent('MODAL_VIEW:HIDE', { title: title.current || null }, 'ModalViewProvider.hideModalView')
    setShow(false)
  }

  /**
   * @param {{ cancelled?: boolean }} [options]
   * When cancelled=true (X button), invokes setupModalView.onCancel if provided.
   */
  function destroyModalView (options = {}) {
    const cancelled = options.cancelled === true
    const onCancel = cancelled ? onCancelRef.current : null
    onCancelRef.current = null
    recordFlightEvent('MODAL_VIEW:DESTROY', {
      title: title.current || null,
      cancelled,
    }, 'ModalViewProvider.destroyModalView')
    setShow(false)
    title.current = null
    content.current = null
    if (typeof onCancel === 'function') {
      try {
        onCancel()
      } catch (e) {
        console.error('[ModalView] onCancel error', e)
      }
    }
  }

  function isModalViewVisible() {
    return show
  }

  function setupModalView(userInfo) {
    title.current = userInfo.title
    content.current = userInfo.content
    onCancelRef.current = typeof userInfo.onCancel === 'function' ? userInfo.onCancel : null
    recordFlightEvent('MODAL_VIEW:SETUP', { title: userInfo?.title || null }, 'ModalViewProvider.setupModalView')

    if (userInfo.actions) {
    } else {
    }
  }

  const value = useMemo(() => {
    return {
      showModalView,
      hideModalView,
      destroyModalView,
      setupModalView
    }
  }, [show])

  return <ModalViewContext.Provider value={ value }>
    <ModalView show={ show } cancelable={ cancelable }
           title={ title.current }
    >
      { content.current }
    </ModalView>
    { children }
  </ModalViewContext.Provider>
}

export function useModalView() {
  const context = useContext(ModalViewContext)

  if (!context) {
    throw new Error('useModalView debe estar dentro del proveedor ModalViewContext')
  }

  return context
}
